import React, { Fragment, useState, useEffect } from "react";
import { Row, Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import ContratoService from "../../../../../services/contrato-auth";
import '../../../../../styles/leis-auth.scss'
import Moment from "moment";

const Contrato = () => {
    let { id } = useParams();
    const [objeto, setObjeto] = useState("");
    const [contratante, setContratante] = useState("");
    const [processo, setProcesso] = useState("");
    const [numero, setNumero] = useState("");
    const [ano, setAno] = useState("");
    const [inicioVigencia, setInicioVigencia] = useState("");
    const [finalVigencia, setFinalVigencia] = useState("");
    const [dataAssinatura, setDataAssinatura] = useState("");
    const [situacao, setSituacao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [contratado, setContratado] = useState("");
    const [cnpj, setCnpj] = useState("");


    async function fetchContrato(id) {
        const response = await ContratoService.contratoEdit(id);
        Moment.locale();
        setObjeto(response.data["objeto"]);
        setProcesso(response.data["processo"]);
        setNumero(response.data["numero"]);
        setContratante(response.data["contratante"]);
        setContratado(response.data["contratado"])
        setDataAssinatura(Moment(response.data["dataAssinatura"]).utc(false).format("DD/MM/YYYY"));
        setDataPub(Moment(response.data["dataPub"]).utc(false).format("DD/MM/YYYY"));
        response.data["ano"] ? setAno(response.data["ano"]) : setAno(response.data["anoProcesso"]);
        setInicioVigencia(Moment(response.data["inicioVigencia"]).utc(false).format("DD/MM/YYYY"));
        setFinalVigencia(Moment(response.data["finalVigencia"]).utc(false).format("DD/MM/YYYY"));
        setSituacao(response.data["situacao"]);
        setCnpj(response.data["cnpj"]);
    }

    useEffect(() => {
        fetchContrato(id)
    }, [id])

    return (
        <Fragment>
            <h5>Contrato Nº {numero} do Processo Nº{processo}/{ano}</h5>
            <Row xs={12}>
                <p><strong>Objeto: </strong>{objeto}</p>
                <p><strong>Contratante: </strong>{contratante}</p>
                <p><strong>Início da Vigência: </strong>{inicioVigencia}</p>
                <p><strong>Final da Vigência: </strong>{finalVigencia}</p>
                <p><strong>Data de Publicação: </strong>{dataPub}</p>
                <p><strong>Data da Assinatura: </strong>{dataAssinatura}</p>
                <p><strong>Situação: </strong>{situacao}</p>
                <p><strong>Contratado (Razão Social): </strong>{contratado}</p>
                <p><strong>CNPJ: </strong>{cnpj}</p>
                

            </Row>
            <Link to={`/restrito/contratos/editar/${id}`}>
                <Button type="button" variant='primary'>Editar</Button>
            </Link>
            <br/><br/>
            <Link to={`/restrito/contratos/listar`}>
                <Button type='button' variant='danger'>Voltar</Button>
            </Link>
        </Fragment >)
}

export default Contrato;